import React, { useState } from "react";
import { uploadFile } from "../../../apis/auth";
import { parseCustomerAddress } from "./customerAddress";

const blankGuarantor = () => ({ name: "", mobile: "", email: "", aadhar_number: "", address: "",
  photo: "", aadharFront: "", aadharBack: "", panCardImage: "" });
const blankAddress = () => ({ addressLine: "", city: "", state: "", country: "", pincode: "" });
const blankPermanentAddress = () => ({ addressLine1: "", city1: "", state1: "", country1: "", pincode1: "" });

export const customerDocuments = [
  ["passportSizePhoto", "Customer photo"], ["aadharImageUrl", "Aadhaar front"],
  ["aadharbackimageurl", "Aadhaar back"], ["panImageUrl", "PAN card"],
  ["bankStatementsImageUrl", "Bank statement"], ["paySlipImageUrl", "Income proof"],
  ["singnatureImageUrl", "Signature"], ["billImage", "Purchase bill"],
];

export const blankEvCustomer = () => ({
  full_name: "", phoneNumber1: "", phoneNumber2: "", email: "", fatherName: "", dob: "",
  gender: "", martialStatus: "", aadharNumber: "", PanNumber: "",
  address: blankAddress(), current_address: blankPermanentAddress(),
  occupation: "", income: "", monthlyExpenses: "", bankName: "", bankAccountNo: "", ifscCode: "",
  guarantor: { first: blankGuarantor(), second: blankGuarantor() },
  ...Object.fromEntries(customerDocuments.map(([key]) => [key, ""])),
});

export function evCustomerForEdit(item) {
  const blank = blankEvCustomer();
  const address = parseCustomerAddress(item.address);
  const permanent = parseCustomerAddress(item.current_address);
  let guarantor = item.guarantor;
  if (typeof guarantor === "string") {
    try { guarantor = JSON.parse(guarantor); } catch { guarantor = {}; }
  }
  return {
    ...blank, ...Object.fromEntries(Object.keys(blank).filter((key) => !["address", "current_address", "guarantor"].includes(key))
      .map((key) => [key, item[key] ?? blank[key]])),
    dob: item.dob ? String(item.dob).slice(0, 10) : "",
    address: { ...blank.address, ...address },
    current_address: { ...blank.current_address, ...permanent,
      addressLine1: permanent.addressLine1 || permanent.addressLine || "" },
    guarantor: { first: { ...blank.guarantor.first, ...(guarantor?.first || {}) },
      second: { ...blank.guarantor.second, ...(guarantor?.second || {}) } },
  };
}

function Field({ label, value, onChange, type = "text", required = false, maxLength, min, step, pattern, title }) {
  const id = `ev_customer_${label.toLowerCase().replace(/[^a-z0-9]+/g, "_")}`;
  return <div className="col-md-4"><label className="form-label" htmlFor={id}>{label}</label>
    <input id={id} className="form-control" type={type} required={required} maxLength={maxLength} min={min} step={step} pattern={pattern} title={title}
      value={value ?? ""} onChange={(event) => onChange(event.target.value)} /></div>;
}

function Document({ label, value, onChange, disabled, onUpload }) {
  const id = `ev_document_${label.toLowerCase().replace(/[^a-z0-9]+/g, "_")}`;
  return <div className="col-md-4"><label className="form-label d-block" htmlFor={id}>{label}</label>
    <input id={id} className="form-control" type="file" accept="image/*,.pdf" disabled={disabled}
      onChange={(event) => onUpload(event, label, onChange)} />
    {value && <div className="mt-1 d-flex align-items-center gap-2">
      {/^https?:\/\//i.test(value) && <a href={value} target="_blank" rel="noopener noreferrer">View uploaded file</a>}
      <button type="button" className="btn btn-sm btn-link text-danger" onClick={() => onChange("")}>Remove</button>
    </div>}
  </div>;
}

export default function EvCustomerForm({ customer, setCustomer, onSubmit, busy, editing, onCancel, onUploadingChange }) {
  const [uploading, setUploading] = useState("");
  const [uploadError, setUploadError] = useState("");
  const change = (key, value) => setCustomer((previous) => ({ ...previous, [key]: value }));
  const changeAddress = (key, field, value) => setCustomer((previous) => ({ ...previous,
    [key]: { ...previous[key], [field]: value } }));
  const changeGuarantor = (which, key, value) => setCustomer((previous) => ({ ...previous,
    guarantor: { ...previous.guarantor, [which]: { ...previous.guarantor[which], [key]: value } } }));

  async function upload(event, label, save) {
    const file = event.target.files?.[0];
    if (!file) return;
    event.target.value = "";
    if (file.size > 10 * 1024 * 1024 || !(file.type === "application/pdf" || file.type.startsWith("image/"))) {
      setUploadError("Choose a PDF or image smaller than 10 MB.");
      return;
    }
    setUploading(label); onUploadingChange(true); setUploadError("");
    try {
      const data = new FormData();
      data.append("image", file);
      const response = await uploadFile(data);
      if (!response.status || !response.data?.image) throw new Error("Upload failed");
      save(response.data.image);
    } catch (error) { setUploadError(error?.response?.data?.message || error.message || "Upload failed"); }
    finally { setUploading(""); onUploadingChange(false); }
  }

  return <form onSubmit={(event) => { if (uploading) event.preventDefault(); else onSubmit(event); }}>
    <h5 className="mb-3">Personal details</h5><div className="row g-3">
      <Field label="Full name" value={customer.full_name} required onChange={(value) => change("full_name", value)} />
      <Field label="Primary phone" type="tel" maxLength={10} pattern="[0-9]{10}" title="Enter 10 digits" value={customer.phoneNumber1} required onChange={(value) => change("phoneNumber1", value)} />
      <Field label="Alternate phone" type="tel" maxLength={10} pattern="[0-9]{10}" title="Enter 10 digits" value={customer.phoneNumber2} onChange={(value) => change("phoneNumber2", value)} />
      <Field label="Email" type="email" value={customer.email} onChange={(value) => change("email", value)} />
      <Field label="Date of birth" type="date" value={customer.dob} onChange={(value) => change("dob", value)} />
      <Field label="Father's name" value={customer.fatherName} onChange={(value) => change("fatherName", value)} />
      <div className="col-md-4"><label className="form-label" htmlFor="ev_customer_gender">Gender</label>
        <select id="ev_customer_gender" className="form-select" value={customer.gender} onChange={(event) => change("gender", event.target.value)}>
          <option value="">Select</option><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option>
        </select></div>
      <div className="col-md-4"><label className="form-label" htmlFor="ev_customer_marital">Marital status</label>
        <select id="ev_customer_marital" className="form-select" value={customer.martialStatus} onChange={(event) => change("martialStatus", event.target.value)}>
          <option value="">Select</option><option value="single">Single</option><option value="married">Married</option>
          <option value="widowed">Widowed</option><option value="divorced">Divorced</option>
        </select></div>
      <Field label="Aadhaar number" maxLength={12} pattern="[0-9]{12}" title="Enter 12 digits" value={customer.aadharNumber} onChange={(value) => change("aadharNumber", value)} />
      <Field label="PAN number" maxLength={10} pattern="[A-Z]{5}[0-9]{4}[A-Z]" title="Enter a valid PAN" value={customer.PanNumber} onChange={(value) => change("PanNumber", value.toUpperCase())} />
    </div>

    <h5 className="mt-4 mb-3">Current address</h5><div className="row g-3">
      {[ ["addressLine", "Address line"], ["city", "City"], ["state", "State"], ["country", "Country"], ["pincode", "PIN code"] ]
        .map(([key, label]) => <Field key={key} label={`Current ${label}`} value={customer.address[key]}
          onChange={(value) => changeAddress("address", key, value)} />)}
    </div>
    <h5 className="mt-4 mb-3">Permanent address</h5><div className="row g-3">
      {[ ["addressLine1", "Address line"], ["city1", "City"], ["state1", "State"], ["country1", "Country"], ["pincode1", "PIN code"] ]
        .map(([key, label]) => <Field key={key} label={`Permanent ${label}`} value={customer.current_address[key]}
          onChange={(value) => changeAddress("current_address", key, value)} />)}
    </div>
    <button type="button" className="btn btn-sm btn-outline-secondary mt-2"
      onClick={() => setCustomer((previous) => ({ ...previous, current_address: {
        addressLine1: previous.address.addressLine, city1: previous.address.city, state1: previous.address.state,
        country1: previous.address.country, pincode1: previous.address.pincode } }))}>Copy current address</button>

    <h5 className="mt-4 mb-3">Employment and bank details</h5><div className="row g-3">
      <Field label="Occupation" value={customer.occupation} onChange={(value) => change("occupation", value)} />
      <Field label="Monthly income" type="number" min="0" step="0.01" value={customer.income} onChange={(value) => change("income", value)} />
      <Field label="Monthly expenses" type="number" min="0" step="0.01" value={customer.monthlyExpenses} onChange={(value) => change("monthlyExpenses", value)} />
      <Field label="Bank name" value={customer.bankName} onChange={(value) => change("bankName", value)} />
      <Field label="Bank account number" value={customer.bankAccountNo} onChange={(value) => change("bankAccountNo", value)} />
      <Field label="IFSC code" value={customer.ifscCode} onChange={(value) => change("ifscCode", value.toUpperCase())} />
    </div>

    <h5 className="mt-4 mb-3">Guarantor details</h5>
    {["first", "second"].map((which, index) => <fieldset key={which} className="border rounded p-3 mb-3">
      <legend className="float-none w-auto px-2 fs-6">Guarantor {index + 1}</legend><div className="row g-3">
        <Field label={`Guarantor ${index + 1} name`} value={customer.guarantor[which].name} onChange={(value) => changeGuarantor(which, "name", value)} />
        <Field label={`Guarantor ${index + 1} phone`} type="tel" maxLength={10} pattern="[0-9]{10}" title="Enter 10 digits" value={customer.guarantor[which].mobile} onChange={(value) => changeGuarantor(which, "mobile", value)} />
        <Field label={`Guarantor ${index + 1} email`} type="email" value={customer.guarantor[which].email} onChange={(value) => changeGuarantor(which, "email", value)} />
        <Field label={`Guarantor ${index + 1} Aadhaar`} maxLength={12} pattern="[0-9]{12}" title="Enter 12 digits" value={customer.guarantor[which].aadhar_number} onChange={(value) => changeGuarantor(which, "aadhar_number", value)} />
        <Field label={`Guarantor ${index + 1} address`} value={customer.guarantor[which].address} onChange={(value) => changeGuarantor(which, "address", value)} />
        {[["photo", "Photo"], ["aadharFront", "Aadhaar front"], ["aadharBack", "Aadhaar back"], ["panCardImage", "PAN card"]]
          .map(([key, label]) => <Document key={key} label={`Guarantor ${index + 1} ${label}`} value={customer.guarantor[which][key]} disabled={!!uploading || busy} onUpload={upload}
            onChange={(value) => changeGuarantor(which, key, value)} />)}
      </div></fieldset>)}

    <h5 className="mt-4 mb-3">Customer documents</h5><div className="row g-3">
      {customerDocuments.map(([key, label]) => <Document key={key} label={label} value={customer[key]} disabled={!!uploading || busy} onUpload={upload}
        onChange={(value) => change(key, value)} />)}
    </div>
    {uploadError && <div className="alert alert-danger mt-3" role="alert">{uploadError}</div>}
    {uploading && <p className="mt-3" role="status">Uploading {uploading}...</p>}
    <button className="btn btn-primary mt-4" disabled={busy || !!uploading}>{editing ? "Save customer" : "Create customer"}</button>
    <button type="button" className="btn btn-outline-secondary mt-4 ms-2" disabled={!!uploading} onClick={onCancel}>Cancel</button>
  </form>;
}
